/**
 * react-resource-router `name` and `path` values for microsite routes.
 * Keep these in sync with the route definitions in `@af/twg-microsite`.
 */
export const HOME_ROUTE_NAME = 'HOME';
export const CLI_ROUTE_NAME = 'CLI';
export const BENCHMARK_ROUTE_NAME = 'BENCHMARK';

export const HOME_ROUTE_PATH = '/';
export const CLI_ROUTE_PATH = '/cli';
export const BENCHMARK_ROUTE_PATH = '/benchmark';

export type MicrositeRouteName =
	| typeof HOME_ROUTE_NAME
	| typeof CLI_ROUTE_NAME
	| typeof BENCHMARK_ROUTE_NAME;
